import {Field, Form, FormikErrors, FormikProps, withFormik} from 'formik';
import * as React from 'react';
import Recaptcha from 'react-recaptcha';
import {IRequestFormExtendedProps} from './request-form';
import {IFormRequestType} from "../../interfaces/FormRequestType";
import {IActionContext} from "@msdyn365-commerce/core-internal";
import {createKasHelpDeskFormEntityAsync} from "../../actions/DataActionExtension.g";

interface IFormValues {
  name: string;
  email: string;
  company: string;
  city: string;
  state: string;
  country: string;
  phone: string;
  requestType: IFormRequestType;
  product: string[];
  requestReason: string;
  requestProduct: string;
  inquiry: string;
  reCaptcha: string;
  reCaptchaKey: string;
}

interface IRequestFormProps {
    actionContext: IActionContext;
    recaptchaKey: string | undefined;
    handleSubmitStatusMessage(isSuccess: boolean):void;
    handleResetStatusMessage():void;
}

// tslint:disable-next-line: max-func-body-length
const InnerForm = (props: FormikProps<IFormValues>) => {
  const { touched, errors, isSubmitting } = props;

  function inquiryLabel(type: IFormRequestType): string {
    switch (type) {
      case IFormRequestType.Service:
        return 'Is there any other information you would like to provide with your request?';
      case IFormRequestType.Quote:
        return 'In order for us to provide you an accurate quote, please provide additional details about your selections (quantity, specific product, etc)';
      default:
        return 'Your Inquiry';
    }
  }

  const verifyCallback = (response: string) => {
      props.values.reCaptcha = response;
  };

  function inquiryRequest(type: IFormRequestType): JSX.Element {
    switch (Number(type)) {
      case IFormRequestType.Quote:
        return (
          <div className='col-sm-12 fg'>
            <label htmlFor='product'>Which of the following Products or Services are of interest to you or your company?</label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='grinderplates' /> Meat Grinder Plates or Knives
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='meatblades' /> Meat Cutting Blades
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='breadblades' /> Bakery or Bread Slicing Blades
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='woodblades' /> Wood Cutting Blades
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='lubricoat' /> Lubricoat
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='cutlery' /> Cutlery
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='handsaws' /> Hand Saws
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='hookeye-sharpener' /> Hook-Eye Sharpener
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='butcher-supplies' /> Butcher Supplies
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='seasonings' />  Meat Seasonings, Spices or Marinades
           </label>
            <label className='choice'>
              <Field type='checkbox' name='product' value='other' /> Other
           </label>
          </div>
        );
      case IFormRequestType.Service:
        return (
          <>
            <div className='col-sm-12 col-md-4 fg'>
              <label htmlFor='requestReason'>What is the reason for your request?</label>
              <Field component='select' id='requestReason' name='requestReason' multiple={false}>
                <option value='servicequestion' aria-selected='false'>Service-Related Question</option>
                <option value='orderissue' aria-selected='false'>Issue with an Order</option>
                <option value='servicerequest' aria-selected='false'>Requesting Service or Repair</option>
                <option value='maintenance' aria-selected='false'>Requesting Maintenance</option>
                <option value='other' aria-selected='false'>Other</option>
              </Field>
            </div>
            <div className='col-sm-12 col-md-4 fg'>
              <label htmlFor='requestProduct'>Product Type (If Applicable)</label>
              <Field component='select' id='requestProduct' name='requestProduct' multiple={false}>
                <option value='na' aria-selected='false'>N/A</option>
                <option value='orderissue' aria-selected='false'>Bandsaw</option>
                <option value='servicerequest' aria-selected='false'>Oven</option>
                <option value='maintenance' aria-selected='false'>Grinder</option>
                <option value='Slicer' aria-selected='false'>Slicer</option>
                <option value='Tenderizer' aria-selected='false'>Tenderizer</option>
                <option value='Product/Seafood Mister' aria-selected='false'>Product/Seafood Mister</option>
                <option value='Washer/Dryer' aria-selected='false'>Washer/Dryer</option>
                <option value='Ice Cream Machine' aria-selected='false'>Ice Cream Machine</option>
                <option value='Fryer' aria-selected='false'>Fryer</option>
                <option value='Dishwasher/Sanitizer' aria-selected='false'>Dishwasher/Sanitizer</option>
                <option value='other' aria-selected='false'>Other</option>
              </Field>
            </div>
          </>
        );
      default:
        return (<div />);
    }
  }

  return (
    <Form translate='false'>
      <div className='col-sm-12 col-md-6 fg'>
        <label htmlFor='name' className='required'>Name</label>
        <Field id='name' name='name' />
        {touched.name && errors.name && <div className='error'>{errors.name}</div>}
      </div>
      <div className='col-sm-12 col-md-6 fg'>
        <label htmlFor='email' className='required'>Email Address</label>
        <Field
          id='email'
          name='email'
          type='email'
        />
        {touched.email && errors.email && <div className='error'>{errors.email}</div>}
      </div>

      <div className='col-sm-12 col-md-6 fg'>
        <label htmlFor='company'>Company Name</label>
        <Field
          id='company'
          name='company'
        />
      </div>
      <div className='col-sm-12 col-md-6 fg'>

        <label htmlFor='phone' className='required'>Phone</label>
        <Field
          id='phone'
          name='phone'
          type='tel'
        />
        {touched.phone && errors.phone && <div className='error'>{errors.phone}</div>}

      </div>
      <div className='col-sm-12 col-md-4 fg'>

        <label htmlFor='city' className='required'>City</label>
        <Field
          id='city'
          name='city'
        />
        {touched.city && errors.city && <div className='error'>{errors.city}</div>}

      </div>
      <div className='col-sm-12 col-md-4 fg'>

        <label htmlFor='state' className='required'>State/Province</label>
        <Field
          id='state'
          name='state'
        />
        {touched.state && errors.state && <div className='error'>{errors.state}</div>}

      </div>
      <div className='col-sm-12 col-md-4 fg'>

        <label htmlFor='country' className='required'>Country</label>
        <Field
          id='country'
          name='country'
        />
        {touched.country && errors.country && <div className='error'>{errors.country}</div>}

      </div>
      <div className='col-sm-12 col-md-4 fg'>

        <label htmlFor='type' className='required'>Request Type</label>
        <Field
          component='select'
          id='requestType'
          name='requestType'
          multiple={false}
        >
          <option value={IFormRequestType.Quote} aria-selected='false'>Request a Quote</option>
          <option value={IFormRequestType.Service} aria-selected='false'>Request Service</option>
        </Field>

      </div>

      {inquiryRequest(props.values.requestType)}
      <div className='col-sm-12 fg'>
        <label htmlFor='inquiry'>{inquiryLabel(props.values.requestType)}</label>
        <Field component='textarea' id='inquiry' name='inquiry' />
      </div>
      {props.values.reCaptchaKey !== '' &&
      <div className='col-sm-12 fg'>
      <br/>
      <Recaptcha
        sitekey={props.values.reCaptchaKey}
        render='explicit'
        theme='light'
        verifyCallback={verifyCallback}
      />
      {touched.reCaptcha && errors.reCaptcha && <div className='error'>{errors.reCaptcha}</div>}

      </div>}
      <div className='col-sm-12 fg'>

        <button className='msc-cta__primary' type='submit' disabled={isSubmitting}>Submit</button>

      </div>
    </Form>
  );
};

const RequestForm = withFormik<IRequestFormProps, IFormValues>({
  mapPropsToValues: props => {
    return {
      name: '',
      email: '',
      company: '',
      phone: '',
      city: '',
      state: '',
      country: '',
      requestType: IFormRequestType.Quote,
      product: [],
      requestReason: 'servicequestion',
      requestProduct: 'na',
      inquiry: '',
      reCaptcha: '',
      reCaptchaKey: props.recaptchaKey || ''
    };
  },
  validate: (values: IFormValues) => {

    const phonetest = /^[0-9+\(\)#\.\s\/ext-]+$/;
    const emailtest = /\S+@\S+\.\S+/;

    const errors: FormikErrors<IFormValues> = {};

    if (values.reCaptchaKey !== '' && !values.reCaptcha) {
      errors.reCaptcha = 'Required';
    }

    if (!values.email) {
      errors.email = 'Required';
    } else if (!emailtest.test(values.email)) {
      errors.email = 'Invalid email address';
    }

    if (!values.phone) {
      errors.phone = 'Required';
    } else if (!phonetest.test(values.phone)) {
      errors.phone = 'Invalid phone number';
    }

    if (!values.name) {
      errors.name = 'Required';
    }

    if (!values.city) {
      errors.city = 'Required';
    }

    if (!values.state) {
      errors.state = 'Required';
    }

    if (!values.country) {
      errors.country = 'Required';
    }

    return errors;
  },

  handleSubmit: async (values, formikbag) => {
      let productString = '';
      console.log(values.requestType);
    if (values.requestType == IFormRequestType.Service) {
        console.log('In Service Request')
        //Remove all product values as they aren't applicable for Service
        values.product = [];
        productString += `Request Reason: \n ${values.requestReason} \n`
        productString += `Request Product: \n ${values.requestProduct} \n`
    }
    if (values.requestType == IFormRequestType.Quote) {
        //Remove values as they aren't applicable for quote
        values.requestReason = '';
        values.requestProduct = '';
        productString += 'Products: \n';
        values.product.forEach(p => {
            productString += `${p} \n`
        })
    }
    const requestBody = productString + 'Inquiry: \n' + values.inquiry;
      await createKasHelpDeskFormEntityAsync(
          {callerContext: formikbag.props.actionContext},
          values.name,
          values.email,
          values.company,
          values.phone,
          values.city,
          values.state,
          values.country,
          'N/A',
          requestBody,
          'KASCO',
          String(values.requestType)
      );
      formikbag.resetForm();
      formikbag.props.handleSubmitStatusMessage(true);
      formikbag.setSubmitting(false);
      setTimeout(() => {
          formikbag.props.handleResetStatusMessage()
      }, 1000 * 15)
  }
})(InnerForm);

const RequestFormView: React.FC<IRequestFormExtendedProps> = (props) => {
    const [isSuccess , setIsSuccess] = React.useState<boolean>(false);
    const [isFailure , setIsFailure] = React.useState<boolean>(false);
    const handleSubmitStatusMessage = (isSuccess: boolean) => {
        if (isSuccess) {
            setIsSuccess(true);
            setIsFailure(false);
        } else {
            setIsFailure(true);
            setIsSuccess(false);
        }
    }
    const handleResetStatusMessage = () => {
        setIsSuccess(false);
        setIsFailure(false);
    }
    return (<>
        <div className='contact-form'>
            <h1>Request a Quote or Service</h1>
            <br/>
            {isSuccess ? <div className={'msc-alert msc-alert-success'}>{props.config.successMessage}</div> : null}
            {isFailure ? <div className="msc-alert msc-alert-danger">There was an error. Please try again.</div> : null}
            <RequestForm
                handleSubmitStatusMessage={handleSubmitStatusMessage}
                handleResetStatusMessage={handleResetStatusMessage}
                actionContext={props.context.actionContext}
                recaptchaKey={props.config.captchaKey}
            />
        </div>
    </>);
};

export default RequestFormView;
